import SmsWidget from '@homeaway/react-sms-widget';
import PropTypes from 'prop-types';
import React from 'react';
import {asyncComponent} from 'react-async-component';

import './Sms.less';

// TODO: Sort out how to properly test and cover the asyncComponent
const AsyncSmsWidget = asyncComponent({
    serverMode: 'defer',
    resolve: /* istanbul ignore next */() => Promise.resolve(SmsWidget),
});

const Sms = (props) => {
    if (!props.data) {
        return null;
    }

    const {data, site} = props;
    const {title} = data;

    return (
        <div className="SiteFooter__Sms">
            <h3>{title}</h3>
            <AsyncSmsWidget site={site} {...data} endpointUrl="/bizops/traveler/smsMe"/>
        </div>
    );
};


Sms.propTypes = {
    className: PropTypes.string,
    data: PropTypes.shape({
        endpointUrl: PropTypes.string,
        title: PropTypes.string,
        countryCode: PropTypes.string,
        countryCodes: PropTypes.object,
        i18n: PropTypes.object,
        phoneNumber: PropTypes.string,
    }),
    site: PropTypes.string.isRequired,
};

export default Sms;
